import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, headers: { "Content-Type": "application/json" } });

// Attach token from localStorage to every request
api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? window.localStorage.getItem("sat_token") : null;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public endpoints
export const subscribeNewsletter = (data) => api.post("/newsletter", data).then(r => r.data);
export const sendContact = (data) => api.post("/contact", data).then(r => r.data);
export const fetchQuizQuestions = (language = "de") => api.get(`/quiz/questions?language=${language}`).then(r => r.data);
export const submitQuiz = (data) => api.post("/quiz/submit", data).then(r => r.data);
export const submitWheel = (data) => api.post("/wheel/submit", data).then(r => r.data);
export const fetchPublicConfig = () => api.get("/public/config").then(r => r.data);

// Auth
export const login = (data) => api.post("/auth/login", data).then(r => r.data);
export const register = (data) => api.post("/auth/register", data).then(r => r.data);
export const fetchMe = () => api.get("/auth/me").then(r => r.data);

// Admin
export const adminStats = () => api.get("/admin/stats").then(r => r.data);
export const adminList = (collection, limit = 200) => api.get(`/admin/${collection}?limit=${limit}`).then(r => r.data);

// LMS
export const listCourses = (language = "de", track) => api.get(`/lms/courses?language=${language}${track ? `&track=${track}` : ""}`).then(r => r.data);
export const getCourse = (slug) => api.get(`/lms/courses/${slug}`).then(r => r.data);
export const enrollCourse = (slug) => api.post(`/lms/courses/${slug}/enroll`).then(r => r.data);
export const myEnrollments = () => api.get("/lms/me/enrollments").then(r => r.data);
export const completeLesson = (slug, lesson_id) => api.post(`/lms/courses/${slug}/lessons/complete`, { lesson_id }).then(r => r.data);
export const attemptQuiz = (slug, module_id, answers) => api.post(`/lms/courses/${slug}/quiz/attempt`, { module_id, answers }).then(r => r.data);
export const certificateUrl = (slug) => `${API}/lms/courses/${slug}/certificate`;

// Payment
export const paymentCatalog = () => api.get("/payment/catalog").then(r => r.data);
export const createCheckout = (product_key) => {
  let referral_code = null;
  try {
    const raw = window.localStorage.getItem("sat_ref");
    if (raw) referral_code = JSON.parse(raw).code;
  } catch (_) {}
  return api.post("/payment/checkout", { product_key, origin_url: window.location.origin, referral_code }).then(r => r.data);
};
export const paymentStatus = (session_id) => api.get(`/payment/status/${session_id}`).then(r => r.data);
export const paymentLink = (product_key) => api.get(`/payment/link/${product_key}`).then(r => r.data);
export const paymentLinks = () => api.get(`/payment/links`).then(r => r.data);

// SAT Stimmen™
export const submitVoiceInquiry = (data) => api.post("/voices/inquiry", data).then(r => r.data);
export const adminListVoiceInquiries = (params = {}) => api.get("/admin/voices/inquiries", { params }).then(r => r.data);
export const adminVoiceInquiriesStats = () => api.get("/admin/voices/inquiries/stats").then(r => r.data);
export const adminUpdateVoiceInquiry = (id, data) => api.patch(`/admin/voices/inquiries/${id}`, data).then(r => r.data);
export const adminSendVoiceOffer = (id, data) => api.post(`/admin/voices/inquiries/${id}/send-offer`, data).then(r => r.data);

// Media
export const listEpisodes = (kind, language = "de") => api.get(`/media/episodes?kind=${kind}&language=${language}`).then(r => r.data);

export const v2GetState = (slug) => api.get(`/lms/v2/courses/${slug}/state`).then(r => r.data);

// --- Block 5 · SAT MENTOR: Submissions + Reviewer ---
export const mentorMySubmissions = () => api.get("/lms/v2/me/submissions").then(r => r.data);
export const mentorGetSubmission = (id) => api.get(`/lms/v2/submissions/${id}`).then(r => r.data);
export const mentorCreateSubmission = (data) => api.post("/lms/v2/submissions", data).then(r => r.data);
export const mentorSubmitSubmission = (id) => api.post(`/lms/v2/submissions/${id}/submit`).then(r => r.data);
export const mentorNewVersion = (id, data) => api.post(`/lms/v2/submissions/${id}/new-version`, data).then(r => r.data);
export const mentorReviewerQueue = (params = {}) =>
  api.get("/lms/v2/reviewer/queue", { params }).then(r => r.data);
export const mentorReviewDecision = (id, data) =>
  api.post(`/lms/v2/submissions/${id}/review`, data).then(r => r.data);
export const mentorPortfolio = (userId) =>
  api.get(`/lms/v2/mentor-portfolio/${userId}`).then(r => r.data);
export const mentorCertificateEvaluate = (userId) =>
  api.post("/lms/v2/mentor-certificates/evaluate", { user_id: userId }).then(r => r.data);

// --- SAT DACH-Gesellschaftsbarometer ---
export const publicStatistics = (params = {}) =>
  api.get("/public/statistics", { params }).then(r => r.data);
export const publicStatisticsOverview = () =>
  api.get("/public/statistics/overview").then(r => r.data);
export const publicStatisticsSources = () =>
  api.get("/public/statistics/sources").then(r => r.data);
export const adminStatisticsList = (params = {}) =>
  api.get("/admin/statistics", { params }).then(r => r.data);
export const adminStatisticsCreate = (data) =>
  api.post("/admin/statistics", data).then(r => r.data);
export const adminStatisticsUpdate = (id, data) =>
  api.patch(`/admin/statistics/${id}`, data).then(r => r.data);
export const adminStatisticsPublish = (id, reason = "") =>
  api.post(`/admin/statistics/${id}/publish`, { reason }).then(r => r.data);
export const adminStatisticsArchive = (id, reason = "") =>
  api.post(`/admin/statistics/${id}/archive`, { reason }).then(r => r.data);
export const adminStatisticsImport = (items, dryRun = true) =>
  api.post("/admin/statistics/import", { items, dry_run: dryRun }).then(r => r.data);
export const adminStatisticsExport = () =>
  api.get("/admin/statistics/export").then(r => r.data);
export const v2GetLesson = (courseSlug, lessonSlug) =>
  api.get(`/lms/v2/courses/${courseSlug}/lessons/${lessonSlug}`).then(r => r.data);
export const v2UpdateProgress = (lessonId, payload) =>
  api.post(`/lms/v2/lessons/${lessonId}/progress`, payload).then(r => r.data);
export const v2PlaybackToken = (assetId) =>
  api.post(`/lms/v2/assets/${assetId}/playback-token`).then(r => r.data);
export const v2SignedDownload = (assetId) =>
  api.get(`/lms/v2/assets/${assetId}/signed-download`).then(r => r.data);

// Admin
export const v2AdminListCourses = () => api.get("/lms/v2/admin/courses").then(r => r.data);
export const v2AdminGetCourse = (courseId) => api.get(`/lms/v2/admin/courses/${courseId}`).then(r => r.data);
export const v2AdminCreateCourse = (data) => api.post("/lms/v2/courses", data).then(r => r.data);
export const v2AdminCreateModule = (courseId, data) =>
  api.post(`/lms/v2/courses/${courseId}/modules`, data).then(r => r.data);
export const v2AdminCreateLesson = (courseId, data) =>
  api.post(`/lms/v2/courses/${courseId}/lessons`, data).then(r => r.data);
export const v2AdminUpdateLesson = (lessonId, data) =>
  api.patch(`/lms/v2/lessons/${lessonId}`, data).then(r => r.data);
export const v2AdminTransition = (lessonId, target, extra = {}) =>
  api.post(`/lms/v2/lessons/${lessonId}/transition`, { target_status: target, ...extra }).then(r => r.data);
export const v2AdminPreflight = (lessonId) =>
  api.get(`/lms/v2/lessons/${lessonId}/preflight`).then(r => r.data);
export const v2AdminCreateAsset = (data) => api.post("/lms/v2/assets", data).then(r => r.data);
export const v2AdminPreview = (courseSlug, days = 0) =>
  api.post("/lms/v2/admin/preview-as-learner", {
    course_slug: courseSlug, simulated_days_after_enrollment: days,
  }).then(r => r.data);
export const v2AdminGrantInternal = (courseSlug, userId) =>
  api.post("/lms/v2/admin/grant-internal-test", { course_slug: courseSlug, user_id: userId }).then(r => r.data);

// Forum
export const listThreads = (category) => api.get(`/forum/threads${category ? `?category=${category}` : ""}`).then(r => r.data);
export const getThread = (id) => api.get(`/forum/threads/${id}`).then(r => r.data);
export const createThread = (data) => api.post("/forum/threads", data).then(r => r.data);
export const addPost = (id, body) => api.post(`/forum/threads/${id}/posts`, { body }).then(r => r.data);
